import React from 'react';
import { SortableElement } from 'react-sortable-hoc';

import { decodeHtml } from 'helpers/utils';

import MatrixAttributesDragHandle from './MatrixAttributesDragHandle';

const MatrixAttributesSortableItem = SortableElement(
  ({ name, attribute, isEditable, i, type, onChangeText, onKeyPress }) => {
    if (attribute.type === 'divider') {
      return <li className="matrix-attributes__item divider">New</li>;
    }

    const key = typeof attribute.newKey !== 'undefined' ? attribute.newKey : attribute.key;

    return (
      <li className="matrix-attributes__item">
        {isEditable ? (
          <MatrixAttributesDragHandle />
        ) : (
          <div className="matrix-attributes__handle-placeholder" />
        )}
        {isEditable ? (
          <input
            type="text"
            className="view_view notranslate"
            autoComplete="off"
            value={decodeHtml(attribute.value)}
            data-automation={`row_${name}`}
            onChange={(e) => {
              onChangeText(name, i, e.nativeEvent.target.value);
            }}
            onKeyPress={onKeyPress}
            size="14"
            maxLength="255"
            id={`view_attribute${attribute.number}_${type}_${key}`}
            name={`attribute${attribute.number}_${type}_${key}`}
          />
        ) : (
          <div className="matrix-attributes__value-placeholder notranslate">
            {decodeHtml(attribute.value)}
          </div>
        )}
      </li>
    );
  }
);

export default MatrixAttributesSortableItem;
